export default "__VITE_ASSET__XltclU7t__"